export enum PanelSettingsTabsEnum {
    Portal = 'portal',
    TradingPlatforms = 'trading-platforms',
    System = 'system'
}
